import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';

function AdminContentReview() {
  const [posts, setPosts] = useState([]);
  const [stats, setStats] = useState({ pending: 0, approved: 0, rejected: 0 });
  const [filter, setFilter] = useState('pending');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editContent, setEditContent] = useState('');

  useEffect(() => {
    fetchPosts();
    fetchStats();
  }, [filter]);

  const getToken = () => localStorage.getItem('accessToken');

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/admin/content-review?status=${filter}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      const data = await res.json();
      setPosts(data.posts || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const fetchStats = async () => {
    try {
      const res = await fetch(`/api/admin/content-review/stats`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      const data = await res.json();
      setStats(data);
    } catch (e) { /* ignore */ }
  };

  const handleApprove = async (postId) => {
    await fetch(`/api/admin/content-review/${postId}/approve`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    fetchPosts();
    fetchStats();
  };

  const handleReject = async (postId) => {
    if (!window.confirm('Reject this post? It will be hidden from users.')) return;
    await fetch(`/api/admin/content-review/${postId}/reject`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    fetchPosts();
    fetchStats();
  };

  const handleEdit = async (postId) => {
    if (editContent.trim().length < 50) {
      alert('Content must be at least 50 characters');
      return;
    }
    await fetch(`/api/admin/content-review/${postId}/edit`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ content: editContent })
    });
    setEditingId(null);
    setEditContent('');
    fetchPosts();
    fetchStats();
  };

  const handleApproveAll = async () => {
    if (!window.confirm(`Approve all ${stats.pending} pending posts?`)) return;
    const res = await fetch(`/api/admin/content-review/approve-all`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    const data = await res.json();
    alert(`Approved ${data.approved} posts`);
    fetchPosts();
    fetchStats();
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
        <h1 style={{ marginBottom: '8px' }}>🤖 AI Content Review</h1>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>Review, edit, and approve AI-generated posts before they go live.</p>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
          {['pending', 'approved', 'rejected'].map(s => (
            <button
              key={s}
              onClick={() => setFilter(s)}
              style={{
                padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                background: filter === s ? '#7c3aed' : '#f3f4f6',
                color: filter === s ? '#fff' : '#374151', fontWeight: 500
              }}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)} ({stats[s] || 0})
            </button>
          ))}
          {filter === 'pending' && stats.pending > 0 && (
            <button onClick={handleApproveAll} style={{ marginLeft: 'auto', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', background: '#10b981', color: '#fff', fontWeight: 500 }}>
              ✅ Approve All ({stats.pending})
            </button>
          )}
        </div>

        {/* Category filter */}
        {posts.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px', color: '#374151' }}
            >
              <option value="">All categories</option>
              {[...new Set(posts.map(p => p.category_name))].sort().map(cat => (
                <option key={cat} value={cat}>{cat} ({posts.filter(p => p.category_name === cat).length})</option>
              ))}
            </select>
          </div>
        )}

        {loading ? (
          <p>Loading...</p>
        ) : posts.length === 0 ? (
          <p style={{ color: '#9ca3af', textAlign: 'center', padding: '40px' }}>No {filter} posts</p>
        ) : (
          <div>
            {/* Group posts by category — filtered */}
            {Object.entries(
              (categoryFilter ? posts.filter(p => p.category_name === categoryFilter) : posts).reduce((groups, post) => {
                const cat = post.category_name || 'Uncategorized';
                if (!groups[cat]) groups[cat] = [];
                groups[cat].push(post);
                return groups;
              }, {})
            ).map(([categoryName, categoryPosts]) => (
              <div key={categoryName} style={{ marginBottom: '28px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #e5e7eb' }}>
                  <h3 style={{ margin: 0, fontSize: '16px', color: '#374151' }}>{categoryName}</h3>
                  <span style={{ fontSize: '12px', color: '#9ca3af', background: '#f3f4f6', padding: '2px 8px', borderRadius: '10px' }}>{categoryPosts.length} posts</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {categoryPosts.map(post => (
              <div key={post.post_id} style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', background: '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
                  <div>
                    <span style={{ fontSize: '13px', background: '#ede9fe', color: '#7c3aed', padding: '3px 8px', borderRadius: '6px' }}>{post.channel_name}</span>
                    <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '8px' }}>{new Date(post.created_at).toLocaleDateString()}</span>
                    {post.human_edited && <span style={{ fontSize: '11px', background: '#fef3c7', color: '#d97706', padding: '2px 6px', borderRadius: '4px', marginLeft: '8px' }}>Edited</span>}
                  </div>
                  <span style={{ fontSize: '12px', color: '#6b7280' }}>/b/{post.channel_slug}</span>
                </div>

                {editingId === post.post_id ? (
                  <div>
                    <textarea
                      value={editContent}
                      onChange={(e) => setEditContent(e.target.value)}
                      style={{ width: '100%', minHeight: '200px', padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '14px', lineHeight: '1.6', resize: 'vertical' }}
                    />
                    <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                      <button onClick={() => handleEdit(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer' }}>Save & Approve</button>
                      <button onClick={() => { setEditingId(null); setEditContent(''); }} style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div>
                    {post.title && <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', marginBottom: '6px' }}>{post.title}</div>}
                    <p style={{ fontSize: '14px', lineHeight: '1.7', color: '#374151', whiteSpace: 'pre-wrap' }}>{post.content}</p>
                    {filter === 'pending' && (
                      <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>
                        <button onClick={() => handleApprove(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer' }}>✅ Approve</button>
                        <button onClick={() => { setEditingId(post.post_id); setEditContent(post.content); }} style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>✏️ Edit</button>
                        <button onClick={() => handleReject(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer' }}>❌ Reject</button>
                      </div>
                    )}
                    {filter === 'approved' && !post.human_edited && (
                      <button onClick={() => { setEditingId(post.post_id); setEditContent(post.content); }} style={{ marginTop: '12px', padding: '6px 12px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>✏️ Edit</button>
                    )}
                  </div>
                )}
              </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminContentReview;
